import PropTypes from "prop-types"
import { connect } from "react-redux"

import { openModal } from "components/modal"
import {
  IS_CA,
  IS_NA,
  // IS_JEWLR,
} from "helpers/application"
import { showHolidayShippingInfoPDP } from "helpers/holiday"
import { cn } from "styles/utils"

import { ActionBtn, Text, ShipDate } from "./components"

const InternalShipText = ({ hasDiamondSelector, holidayDelivery, ship }) => {
  // const holidayDelivery =
  //   ship?.min_delivery_date &&
  //   new Date(ship.min_delivery_date).getDate() <=
  //     new Date(sl.config.guaranteed_receive_date).getDate()
  const is_ca = IS_CA()
  const is_na = IS_NA()

  const holidayStyle = showHolidayShippingInfoPDP() && holidayDelivery
  const cutoffStyle = showHolidayShippingInfoPDP() && !holidayDelivery

  const showShippingInfo = () => openModal("#shipping-info")

  if (ship.delivery_dates?.length > 0) {
    if (ship.delivery_dates.length === 2) {
      const free_is_range = ship.delivery_dates[1].date_range
      const express_is_range = ship.delivery_dates[0].date_range
      return (
        <div className={cn(holidayStyle && "tablet:mb-0 -mb-8")}>
          <Text
            cutoffStyle={cutoffStyle}
            holidayStyle={holidayStyle}
            second={!is_na}
          >
            {express_is_range && (
              <>
                Get it{" "}
                <ShipDate
                  cutoffStyle={cutoffStyle}
                  holidayStyle={holidayStyle}
                  second={!is_na}
                >
                  {ship.delivery_dates[0].date_range[0]}
                </ShipDate>{" "}
                to{" "}
                <ShipDate
                  cutoffStyle={cutoffStyle}
                  holidayStyle={holidayStyle}
                  second={!is_na}
                >
                  {ship.delivery_dates[0].date_range[1]}
                </ShipDate>{" "}
                with{" "}
              </>
            )}
            {!express_is_range && (
              <>
                Get it by{" "}
                <ShipDate
                  cutoffStyle={cutoffStyle}
                  holidayStyle={holidayStyle}
                  second={!is_na}
                >
                  {ship.delivery_dates[0].date}
                </ShipDate>{" "}
                with{" "}
              </>
            )}
            <ShipDate
              cutoffStyle={cutoffStyle}
              holidayStyle={holidayStyle}
              second={!is_na}
            >
              {ship.delivery_dates[0].type}
            </ShipDate>
          </Text>
          {/* <Text holidayStyle={(is_au || is_uk) && holidayDelivery}> */}
          <Text
            cutoffStyle={cutoffStyle}
            holidayStyle={holidayStyle}
            second={is_na}
          >
            {free_is_range && (
              <>
                Get it{" "}
                <ShipDate
                  cutoffStyle={cutoffStyle}
                  holidayStyle={holidayStyle}
                  second={is_na}
                >
                  {ship.delivery_dates[1].date_range[0]}
                </ShipDate>{" "}
                to{" "}
                <ShipDate
                  cutoffStyle={cutoffStyle}
                  holidayStyle={holidayStyle}
                  second={is_na}
                >
                  {ship.delivery_dates[1].date_range[1]}
                </ShipDate>{" "}
                with{" "}
              </>
            )}
            {!free_is_range && (
              <>
                Get it by{" "}
                <ShipDate
                  cutoffStyle={cutoffStyle}
                  holidayStyle={holidayStyle}
                  second={is_na}
                >
                  {ship.delivery_dates[1].date}
                </ShipDate>{" "}
                with{" "}
              </>
            )}
            <ShipDate
              cutoffStyle={cutoffStyle}
              holidayStyle={holidayStyle}
              second={is_na}
            >
              {ship.delivery_dates[1].type}
            </ShipDate>
          </Text>
          {is_ca && (
            <ActionBtn onClick={() => showShippingInfo()}>
              Change your postal code
            </ActionBtn>
          )}
        </div>
      )
    } else {
      // Only one shipping method
      return (
        <>
          <Text cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
            Get it by{" "}
            <ShipDate cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
              {ship.delivery_dates[0].date}
            </ShipDate>{" "}
            with{" "}
            <ShipDate cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
              {ship.delivery_dates[0].type}
            </ShipDate>
            .
          </Text>
          {is_ca && !hasDiamondSelector && (
            <div>
              <ActionBtn onClick={() => showShippingInfo()}>
                Change your postal code
              </ActionBtn>
            </div>
          )}
        </>
      )
    }
  } else if (ship.delivery_date_range) {
    // CA no postal code
    return (
      <div className={cn(holidayStyle && "mb-8")}>
        <Text cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
          Get it{" "}
          <ShipDate cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
            {ship.delivery_date_range[0]}
          </ShipDate>{" "}
          to{" "}
          <ShipDate cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
            {ship.delivery_date_range[1]}
          </ShipDate>{" "}
          with{" "}
          {/* <ShipDate cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
            {IS_JEWLR() ? "FREE" : "Standard"} Shipping
          </ShipDate>
          . */}
        </Text>
        {/*        <Text cutoffStyle={cutoffStyle} holidayStyle={holidayStyle} second>
          To find out exact delivery date{" "}
          <ActionBtn
            className="mx-0"
            data-cy="change-postal-button"
            onClick={() => showShippingInfo()}
          >
            check your postal code
          </ActionBtn>
          .
        </Text>*/}

        <Text>Your exact delivery dates will be calculated at checkout</Text>
      </div>
    )
  } else if (ship.view_type === "OUT_OF_STOCK") {
    return (
      <Text>
        We&apos;re sorry, this item is currently unavailable. Please check back
        soon!
      </Text>
    )
  } else {
    // Default no ship methods returned
    return (
      <Text cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
        Get it by{" "}
        <ShipDate cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
          {ship.esd}
        </ShipDate>
        .
      </Text>
    )
  }
}

InternalShipText.propTypes = {
  hasDiamondSelector: PropTypes.bool,
  holidayDelivery: PropTypes.bool,
  ship: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    hasDiamondSelector: state.wizard.hasDiamondSelector,
    holidayDelivery: state.wizard.shipping.main?.available_holiday_delivery,
    ship: state.wizard.shipping.main,
  }
}

const ShipText = connect(mapStateToProps)(InternalShipText)

export default ShipText
